<template>
    <v-card rounded="0" height=100%>
        <v-img class="news-entry-header-wrapper" :style="{backgroundColor: '#00B4B0'}">
            <v-card-text class="d-flex news-entry-headline-text justify-center align-center">
                <v-icon class="mdi-icon" color="white">mdi-bullhorn-outline</v-icon>
                <span style="width: 60vw;">{{ playoutNews !== null ? playoutNews.title : $t("playout.news.empty-headline") }}</span>
            </v-card-text>
        </v-img>
        <div class="news-wrapper">
            <template v-if="playoutNews !== null">
                {{playoutNews.description}}
            </template>
            <template v-else>
                <center>
                    {{ $t("playout.news.empty") }}
                </center>
            </template>
        </div>

    </v-card>
</template>
<style lang="scss" scoped>
.news-wrapper{
    height: calc(100% - 10vh);
    display: flex;
    flex-grow: 1;
    font: normal normal normal 5vh/6vh 'RobotoRegular' !important;
    color: $font-color !important;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 6vh 6vw;
}
.news-entry-header-wrapper{
    height: 14vh;
}
.news-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.mdi-icon{
    font-size: 9vh !important;
}
.bold {
    font-weight: bold;
}
.hide {
    opacity: 0;
}
</style>
<script>
export default {
    data() {
        return {
            playoutNews: null
        }
    },
    created() {
        this.$store.dispatch({
            type: 'moduleNews/fetchNews',
        }).then(() => {
            if(this.playoutNews === null) {
                this.setPlayoutNews();
            }
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
        this.setPlayoutNews();
    },
    methods: {
        setPlayoutNews() {
            if(this.news.length == 0 || this.nextPlayoutNews >= this.news.length) {
                this.playoutNews = null;
            } else {
                this.playoutNews = this.news[this.nextPlayoutNews];
            }
            let newInt = this.news.length <= (1 + this.nextPlayoutNews) ? 0 : 1 + this.nextPlayoutNews;
            this.$store.commit('moduleNews/setNextPlayoutNews', {'nextPlayoutNews': newInt});
        }
    },
    computed: {
        news() {
            return this.$store.getters['moduleNews/playoutNews'];
        },
        nextPlayoutNews() {
            return this.$store.getters['moduleNews/nextPlayoutNews'];
        },
    }
}
</script>
